module.exports = __webpack_public_path__ + "static/media/covidTarot.9e46cc59.gif";